export enum DrmType {
  All,
  SamsungLynk,
  Cenc,
  Cenc2,
  Playready,
  Proidiom,
  Widevine,
  Cmaf,
  AES,
  SecretAgent
}
